import React from 'react';
import ButtonComponent from 'components/Button/index';
import { useHistory } from 'react-router-dom';
import LandingFas from 'assets/img/LandingFas.svg';
import LogoSefaz from 'assets/img/logoSefazVerticalVazadaBranca.svg';
import { privateRoot, publicRoot } from 'routes/paths';
import { altImageHome, altImageSefaz } from 'utils/acessibilidade';
import * as S from './styles';

export default function Home() {
  const history = useHistory();
  return (
    <S.Page>
      <S.Imagem src={LandingFas} title="Imagem inicial FAS" alt={altImageHome} data-testid="imagemInicialFas" />
      <S.PageTexto>
        <S.ImagemLogo
          src={LogoSefaz}
          title="Imagem nome logo SEFAZ"
          alt={altImageSefaz}
          data-testid="imagemInicialSefaz"
        />
        <S.Subtitulo>Agora ficou mais fácil de ver todas as suas solicitações na SEFAZ!</S.Subtitulo>
        <S.ContainerButton>
          <ButtonComponent text="ACESSE AQUI" clickAction={() => history.push(privateRoot)} color="white" />
        </S.ContainerButton>
        <p className="link" onClick={() => history.push(publicRoot)}>
          Ou acesse aqui para visualizar sem login.
        </p>
      </S.PageTexto>
    </S.Page>
  );
}
